<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
    <title>Opzioni</title>
    <path
      d="M11,1c2.76,0,5.262,1.12,7.07,2.93,1.81,1.81,2.93,4.31,2.93,7.07s-1.12,5.262-2.93,7.07c-1.81,1.81-4.31,2.93-7.07,2.93s-5.262-1.12-7.07-2.93c-1.81-1.808-2.93-4.308-2.93-7.07s1.12-5.26,2.93-7.07c1.808-1.81,4.308-2.93,7.07-2.93h0ZM11,16.023c-.649,0-1.177-.527-1.177-1.175s.527-1.175,1.177-1.175,1.177.527,1.177,1.175-.527,1.175-1.177,1.175h0ZM11,8.16c-.649,0-1.177-.526-1.177-1.175s.527-1.175,1.177-1.175,1.177.526,1.177,1.175-.527,1.175-1.177,1.175h0ZM11,12.092c-.649,0-1.177-.527-1.177-1.175s.527-1.175,1.177-1.175,1.177.527,1.177,1.175-.527,1.175-1.177,1.175h0ZM16.897,5.102c-1.509-1.509-3.594-2.441-5.897-2.441s-4.388.934-5.897,2.443c-1.51,1.509-2.443,3.594-2.443,5.897s.934,4.388,2.443,5.898c1.509,1.509,3.594,2.443,5.898,2.443s4.388-.934,5.897-2.443c1.509-1.509,2.443-3.594,2.443-5.898-.002-2.303-.934-4.388-2.445-5.898h0Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {};
</script>
